/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import { Motion, spring } from 'react-motion';
import styled from '@emotion/styled';

import { _ExpandCarrot } from './RequirementsOld/styles';

const SeeMoreCarrot = ({
  expanded,
  fontSize = '12px',
  lessFontAwesomeIcon = 'caret-up',
  lessText = 'See Less',
  moreFontAwesomeIcon = 'caret-down',
  moreText = 'See More',
  noMargin,
  onClick,
  marginRight,
}) =>
  expanded ? (
    <_ExpandCarrot
      fontSize={fontSize}
      marginRight={marginRight}
      noMargin={noMargin}
      onClick={onClick}
    >
      {lessText} <FontAwesome name={lessFontAwesomeIcon} />
    </_ExpandCarrot>
  ) : (
    <_ExpandCarrot
      fontSize={fontSize}
      marginRight={marginRight}
      noMargin={noMargin}
      onClick={onClick}
    >
      {moreText} <FontAwesome name={moreFontAwesomeIcon} />
    </_ExpandCarrot>
  );

/**
 * @deprecated use ShowMore from ui-components
 */
class SeeMore extends React.Component {
  constructor(props) {
    super(props);

    this.setExpanded = this.setExpanded.bind(this);
    this.toggleExpanded = this.toggleExpanded.bind(this);
    this.setElementHeight = this.setElementHeight.bind(this);
    this.updateShowSeeMore = this.updateShowSeeMore.bind(this);

    const expanded = props.expanded === undefined ? false : props.expanded;

    this.state = {
      expanded,
      componentMaxHeight: 5000,
      showSeeMore: false,
      hasContentHidden: false,
    };
  }

  componentDidMount() {
    this.setElementHeight();
    window.addEventListener('resize', this.setElementHeight);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setElementHeight);
  }

  componentDidUpdate() {
    this.setElementHeight();
    this.updateShowSeeMore();
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps) {
    if (nextProps.expanded !== this.props.expanded) {
      this.setState({ expanded: nextProps.expanded });
    }
  }

  setExpanded(value) {
    this.setState({ expanded: value }, () => {
      if (this.props.onChange) {
        this.props.onChange(this.state.expanded);
      }
    });
  }

  toggleExpanded() {
    this.setState(
      ({ expanded }) => ({ expanded: !expanded }),
      () => {
        this.updateShowSeeMore();

        if (this.props.onChange) {
          this.props.onChange(this.state.expanded);
        }
      },
    );
  }

  setElementHeight() {
    if (!this.element) return;
    const elementHeight = this.element.scrollHeight;

    if (elementHeight != this.state.componentMaxHeight) {
      this.setState({ componentMaxHeight: elementHeight }, this.updateShowSeeMore);
    }

    if (this.props.onElementHiddenChanged) {
      if (elementHeight > this.props.minimumContentHeight) {
        this.props.onElementHiddenChanged(true);
      } else {
        this.props.onElementHiddenChanged(false);
      }
    }
  }

  updateShowSeeMore() {
    const { alwaysShowSeeMore, minimumContentHeight } = this.props;

    const { showSeeMore, componentMaxHeight, expanded } = this.state;

    if (alwaysShowSeeMore || expanded) {
      if (!showSeeMore) {
        this.setState({ showSeeMore: true });
      }
      return;
    }

    if (componentMaxHeight <= minimumContentHeight) {
      if (showSeeMore) {
        this.setState({ showSeeMore: false });
      }
    } else if (!showSeeMore) {
      this.setState({ showSeeMore: true });
    }
  }

  renderSeeMoreLessToggle() {
    const { showSeeMore, expanded } = this.state;
    if (this.props.hideCarrot) return null;
    const { toggleExpanded } = this;
    if (!showSeeMore) return null;

    return <SeeMoreCarrot onClick={toggleExpanded} expanded={expanded} />;
  }

  calcStyle(interpolatingStyle) {
    const returnValue = { ...interpolatingStyle };
    if (interpolatingStyle.maxHeight === 0) {
      returnValue.maxWidth = 0;
    }

    return returnValue;
  }

  render() {
    const { setExpanded } = this;
    const { toggleExpanded } = this;

    const { className, springConfig, minimumContentHeight } = this.props;

    const { componentMaxHeight, expanded } = this.state;

    const childrenProps = { expanded, setExpanded, toggleExpanded };

    const children = React.Children.map(this.props.children, child =>
      React.cloneElement(child, childrenProps),
    );

    const currentHeight = expanded ? componentMaxHeight * 1.5 : minimumContentHeight;

    const motionStyle = {
      maxHeight: spring(currentHeight, springConfig),
    };

    return (
      <div className={className}>
        <Motion style={motionStyle}>
          {interpolatingStyle => (
            <div style={this.calcStyle(interpolatingStyle)} className="wrapped-content">
              <div
                ref={element => {
                  this.element = element;
                }}
              >
                {children}
              </div>
            </div>
          )}
        </Motion>
        {this.renderSeeMoreLessToggle()}
      </div>
    );
  }
}

SeeMore.propTypes = {
  onChange: PropTypes.func,
  onElementHiddenChanged: PropTypes.func,
};

SeeMore.defaultProps = {
  className: undefined,
  minimumContentHeight: 0,
  springConfig: { stiffness: 200, damping: 20 },
  seeMore: undefined,
  seeLess: undefined,
  alwaysShowSeeMore: false,
  hideCarrot: false,
};

const SeeMoreStyled = styled(SeeMore)`
  & > .wrapped-content {
    overflow-y: ${props => {
      if (props.overflow && props.expanded) {
        return props.overflow;
      }
      return 'hidden';
    }};
    text-align: start;
  }
`;

export { SeeMoreCarrot };

export default SeeMoreStyled;
